import { UserManualsPage } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard, RequiresUsertypesGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(
    UserManualsPage,
    '/user-manuals',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['agency-owner', 'internal-admin', 'internal-staff', 'system-admin']),
    ],
    {
      name: 'Backoffice User Manuals',
    }
  ),
]
